import { useBreakpointValue } from "@chakra-ui/react"

export const useCarouselSizeThumnail = () => {
  const thumbnailHeight =
    useBreakpointValue({
      base: 51,
      md: 92,
      lg: 116,
    }) ?? 116

  const thumbnailWidth =
    useBreakpointValue({
      base: 51,
      md: 92,
      lg: 116,
    }) ?? 116

  return { thumbnailWidth, thumbnailHeight }
}
